import { Grid, Paper, Tab, Tabs } from "@mui/material";
import {
  changeCount,
  changeSelectedRows,
  resetTransmissionState,
  setRoute,
} from "app/store/transmission/slice/transmissionSlice";
import { useGetReportsCountQuery } from "app/store/transmission/api/transmissionTableApi";
import TabLabel from "components/pages/transmissions/tabs/label/TabLabel";
import {
  PATCH_TABS,
  patchTabRoute,
} from "pages/patchMonitoring/patchMonitoring.config";

import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

/* The three clinic stages, each showing how many reports are waiting in it. Every visitor
 * sees all three — the route and the nav entry already restrict the page to clinic roles.
 */
const PatchMonitoringTabs = ({ view, isLoading, tabStyles }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { transmissionCount } = useSelector((state) => state.transmission);

  const { data } = useGetReportsCountQuery(
    { patch: true },
    { refetchOnMountOrArgChange: true }
  );

  const applyCounts = useCallback(
    () =>
      Object.entries(data ?? {}).forEach(([key, value]) =>
        dispatch(changeCount({ view: key, count: value }))
      ),
    [data, dispatch]
  );

  useEffect(() => {
    applyCounts();
  }, [applyCounts]);

  const onTabChange = (_event, value) => {
    // Same order as the transmissions tabs: reset first, then restore the counts the
    // reset cleared. Column filters reset in useTransmissionTable on view change.
    dispatch(changeSelectedRows({}));
    dispatch(resetTransmissionState());
    dispatch(setRoute(value));
    applyCounts();
    navigate(patchTabRoute(value));
  };

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Paper
          square
          elevation={0}
          style={{
            position: "relative",
            top: "1px",
            zIndex: 1000,
            backgroundColor: "transparent",
          }}
        >
          <Tabs
            value={view}
            onChange={onTabChange}
            indicatorColor="secondary"
            TabIndicatorProps={{ style: { top: 0, borderBottom: "none" } }}
            textColor="secondary"
            aria-label="Patch monitoring stages"
          >
            {PATCH_TABS.map((tab) => (
              <Tab
                key={tab.value}
                label={
                  <TabLabel
                    label={tab.label}
                    count={transmissionCount?.[tab.value]}
                  />
                }
                value={tab.value}
                disabled={isLoading}
                sx={{ fullWidth: true }}
                style={tabStyles(tab.value, true)}
              />
            ))}
          </Tabs>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PatchMonitoringTabs;
